import * as disableCarrierComponents from "./container/DisableCarrier";
import * as autoAssignCarrierComponents from "./container/AutoAssign";
import * as rules from "./container/AddRule";

const Carriers = disableCarrierComponents.Carriers;
const CarriersRules = autoAssignCarrierComponents.CarriersRules;
const RulesContainer = rules.RulesContainer;

export { Carriers, CarriersRules, RulesContainer };
